export const formatAddress = (
  address1: string,
  city: string,
  postal: string,
  state: string,
  address2?: string,
) => `${address1!} ${address2 || ''} ${city!}, ${state!} ${postal!}`;
